import { AbridgedEntity } from '.';

export default class Relationship {
  id: string;

  universeId: string;

  fieldId: string;

  to: AbridgedEntity;

  constructor(obj: any) {
    this.id = obj.id;
    this.universeId = obj.universeId;
    this.fieldId = obj.fieldId;
    this.to = new AbridgedEntity(obj.to);
  }
}
